import React from 'react'
import './Navbar2.css'
const Navbar2 = () => {
  return (
    <div className='flipzonediv' style={{fontWeight:'600',fontSize:'18px',padding:'5px',fontFamily:'cursive',color:'gray'}}>
      AnyTime on <span className='flip'>Flip</span><span className='zone'>Zone</span>
    </div>
  )
}

export default Navbar2
